
<transition-group :tag="tag" :class="className" :mode="mode" :css="false" @enter="onEnter" @leave="onLeave">
  <slot></slot>
</transition-group>
